import React from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';

import {cn} from 'spa/css';

import './side-panel-header.less';

@observer
class SidePanelHeader extends React.Component {
  static propTypes = {
    icon: PropTypes.string.isRequired,
    name: PropTypes.string,
    noTopPadding: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
  }

  static defaultProps = {
    name: null,
    noTopPadding: false,
  };

  render() {
    const {
      icon,
      name,
      noTopPadding,
      onClose,
    } = this.props;

    return (
      <header className="side-panel-header">
        <div
          className={cn(
            'side-panel-header__close-button',
            noTopPadding && 'side-panel-header__close-button--no-top-padding',
          )}
          onClick={onClose}
        >
          <img width="20" height="20" src={icon} alt="" />
        </div>
        <h1 className="side-panel-header__heading">{name}</h1>
      </header>
    );
  }
}

export default SidePanelHeader;



// WEBPACK FOOTER //
// ./spa/Components/SidePanel/SidePanelHeader.jsx